import { render, staticRenderFns } from "./Trashed.vue?vue&type=template&id=0846b15e&scoped=true"
import script from "./Trashed.vue?vue&type=script&lang=js"
export * from "./Trashed.vue?vue&type=script&lang=js"
import style0 from "./Trashed.vue?vue&type=style&index=0&id=0846b15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0846b15e",
  null
  
)

export default component.exports